import React from 'react';
import './UniversityPage.css';

const UniversityPage2 = () => {
    return (
        <>
            <div className="containerr">
                <header className="header">
                    <h1>University of Rome Tor Vergata</h1>
                    <h2>Medicine and Surgery Program</h2>
                </header>

                <section className="overview">
                    <h2>Overview</h2>
                    <p>Founded in 1982, the University of Rome Tor Vergata is one of Italy’s top-ranked universities, offering a prestigious Medicine and Surgery program in English. It is known for its academic excellence, modern facilities, and strong focus on research and clinical training. Located in the heart of Rome, the university provides an exceptional learning experience for international students.</p>
                </section>

                <section className="ranking">
                    <h2>International Ranking of Tor Vergata</h2>
                    <p>The University of Rome Tor Vergata ranked 14th in Italy, 432nd in the global 2024 rating, and scored in the TOP 50% across 201 research topics. It is recognized for its excellence in medical education, research, and international collaborations.</p>
                    <a href="https://medschool.uniroma2.it/university-ranking/">University Ranking</a>
                </section>

                <section className="admission">
                    <h2>Admission Requirements</h2>
                    <p>To apply for Tor Vergata’s Medicine and Surgery program, students must meet the following criteria:</p>
                    <ul>
                        <li>Have completed high school (equivalent to 12 years of education).</li>
                        <li>Pass the IMAT exam, which includes sections on biology, chemistry, physics, math, and logical reasoning.</li>
                        <li>Meet the visa and residence permit requirements (for non-EU students).</li>
                        <li>Submit English proficiency proof (if applicable).</li>
                    </ul>

                    <section className="ranking">
                    <h3>IMAT Scores and Cut-Offs (Past Years)</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Year</th>
                                <th>Non-EU Minimum Score</th>
                                <th>EU First/Last Round Scores</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>2020</td>
                                <td>34</td>
                                <td>First: 52.9 / Last: 42.1</td>
                            </tr>
                            <tr>
                                <td>2021</td>
                                <td>47.7</td>
                                <td>First: 45.2 / Last: 37.7</td>
                            </tr>
                            <tr>
                                <td>2022</td>
                                <td>44.6</td>
                                <td>First: 46 / Last: 39.2</td>
                            </tr>
                            <tr>
                                <td>2023</td>
                                <td>53.4</td>
                                <td>First: 40.2 / Last: 39.2</td>
                            </tr>
                            <tr>
                                <td>2024</td>
                                <td>60.6</td>
                                <td>First: 62 / Last: 59.5</td>
                            </tr>
                        </tbody>
                    </table>
                    </section>
                </section>

                <section className="course-structure">
                    <h2>Course Structure and Subjects Taught</h2>
                    <p>The Medicine and Surgery program lasts six years and follows an integrated approach. Key subjects taught include:</p>
                    <h3>First Year</h3>
                    <ul>
                        <li>Scientific Writing and Research Communication</li>
                        <li>Physics and Statistics</li>
                        <li>Human Anatomy I</li>
                        <li>Chemistry and Introductory Biochemistry</li>
                        <li>Biology</li>
                        <li>Histology and Embryology</li>
                        <li>Clinical Practice I</li>
                    </ul>
                    <h3>Second Year</h3>
                    <ul>
                        <li>Physiology</li>
                        <li>Immunology and Immunopathology</li>
                        <li>Human Anatomy II</li>
                        <li>Biochemistry and Molecular Biology</li>
                        <li>Microbiology</li>
                        <li>Clinical Practice II</li>
                    </ul>
                    <h3>Third Year</h3>
                    <ul>
                        <li>Clinical Symptomatology</li>
                        <li>General Pathology and Physiopathology</li>
                        <li>Laboratory Medicine</li>
                        <li>Human Sciences</li>
                        <li>Systemic Pathology I</li>
                        <li>Clinical Practice III</li>
                    </ul>

                    <h3>Fourth Year</h3>
                    <ul>
                        <li>Anatomic Pathology</li>
                        <li>Pharmacology</li>
                        <li>Public Health</li>
                        <li>Systemic Pathology II</li>
                        <li>Systemic Pathology III</li>
                    </ul>

                    <h3>Fifth Year</h3>
                    <ul>
                        <li>Diagnostic Imaging and Radiotherapy</li>
                        <li>Musculoskeletal System Diseases</li>
                        <li>Neurological Sciences</li>
                        <li>Psychiatry</li>
                        <li>General Surgery</li>
                        <li>Internal Medicine and Genetics</li>
                        <li>Obstetrics and Gynecology</li>
                        <li>Pediatric Sciences</li>
                    </ul>

                    <h3>Sixth Year</h3>
                    <ul>
                        <li>Dermatology and Plastic Surgery</li>
                        <li>General Surgery</li>
                        <li>Internal Medicine and Genetics</li>
                        <li>Specialistic Disciplines</li>
                        <li>Clinical Practice VI</li>
                        <li>Emergencies</li>
                        <li>Forensic Medicine</li>
                    </ul>
                </section>

                <section className="exams">
                    <h2>Exams and Grading System</h2>
                    <p>Exams at Tor Vergata can be written, oral, or practical, depending on the subject. The grading system follows a 30-point scale, where:</p>
                    <ul>
                        <li>18/30 is the minimum passing mark.</li>
                        <li>30/30 cum laude is the highest grade.</li>
                    </ul>
                    <p>Students have the choice to accept or reject the score. Each subject has a specific number of credits which will be granted once the subject is passed.</p>
                </section>

                <section className="scholarships">
                    <h2>Scholarships and Tuition Fees</h2>
                    <p>The standard tuition fee is around €156-3500 per year, but it depends on the student’s ISEE (economic status indicator). Most students pay €156 per year, with €140 refunded if they receive a scholarship.</p>
                    <p>Scholarships are available for international students based on merit and financial need. The main organization that provides scholarships in the Lazio region is Disco Lazio.</p>
                    <a href="http://www.laziodisco.it/">Disco Lazio Scholarships</a>
                </section>

                <section className="city-info">
                    <h2>Rome as a City</h2>
                    <p>Studying in Rome offers a blend of rich history, culture, and modern city life. The city provides students with world-class museums, historical sites, delicious food, and a vibrant international community.</p>
                </section>

                <section className="living-expenses">
                    <h2>Living Expenses in Rome</h2>
                    <ul>
                        <li><strong>Accommodation:</strong> €300-€700 per month (shared/private apartment).</li>
                        <li><strong>Food:</strong> €150-€250 per month.</li>
                        <li><strong>Transport:</strong> €35 for a student metro pass for a month or €250 for a yearly pass (discounted to €120-150 for scholarship holders).</li>
                    </ul>
                    <p>Total estimated monthly cost: €500-1000.</p>
                </section>

                <footer className="footer">
                    <h2>Conclusion</h2>
                    <p>The University of Rome Tor Vergata offers a world-class Medicine and Surgery program, combining academic excellence, hands-on clinical training, and an enriching student experience. With its affordable tuition fees, strong international ranking, and vibrant student life in Rome, it is an excellent choice for aspiring medical professionals looking to study in Italy.</p>
                </footer>
            </div>
        </>
    );
};

export default UniversityPage2;